<template>
	<div v-if="visible" class="loading" />
</template>

<script>
export default {
	name: 'loading',

	props: {
		visible: {
			default: null,
			type: Boolean,
		},
	},
}
</script>
